import { jsx as r } from "react/jsx-runtime";
import { isValidElement as i } from "react";
const o = ({
  footer: e
}) => !e || !i(e) ? null : /* @__PURE__ */ r("footer", { className: "SidePanel-footer", children: e });
export {
  o as SidePanelFooter
};
//# sourceMappingURL=SidePanelFooter.mjs.map
